
export const REQUESTS_UPDATE_PRODUCT_FINISHED = "REQUESTS_UPDATE_PRODUCT_FINISHED";
export const REQUESTS_DELETE_PRODUCT_FINISHED = "REQUESTS_DELETE_PRODUCT_FINISHED";
export const REQUESTS_ADD_PRODUCT_FINISHED = "REQUESTS_ADD_PRODUCT_FINISHED";
export const PRE_REQUEST_DELETE_PRODUCT = "PRE_REQUEST_DELETE_PRODUCT";
export const PRE_REQUEST_UPDATE_PRODUCT = "PRE_REQUEST_UPDATE_PRODUCT";
export const PRE_REQUEST_ADD_PRODUCT = "PRE_REQUEST_ADD_PRODUCT";
export const PRE_DELETE_PRODUCT = "PRE_DELETE_PRODUCT";
export const PRE_UPDATE_PRODUCT = "PRE_UPDATE_PRODUCT";
export const PRE_ADD_PRODUCT = "PRE_ADD_PRODUCT"
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const ADD_PRODUCT = "ADD_PRODUCT";

export const REQUESTS_UPDATE_MENU_FINISHED = "REQUESTS_UPDATE_MENU_FINISHED";
export const PRE_REQUEST_UPDATE_MENU = "PRE_REQUEST_UPDATE_MENU"; 
export const PRE_UPDATE_MENU = "PRE_UPDATE_MENU";
export const UPDATE_MENU = "UPDATE_MENU"; 

export const PRE_DELETE_MENU = "PRE_DELETE_MENU"
export const DELETE_MENU = "DELETE_MENU"

export const CLICKED_CATEGORY = "CLICKED_CATEGORY"
export const CLICKED_PRODUCT = "CLICKED_PRODUCT"